import React from 'react';
import { forwardRef } from 'react';

import MaterialTable from "material-table";

import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};


const PalletEventsTable = ({press, jobs, pallets, startDate, endDate}) => {

    const start = startDate.getTime();
    const end = endDate.getTime();
    const inRange = (evtDate) => {return evtDate.getTime() <= end && evtDate.getTime() >= start};

    const events = [];
    jobs.forEach(job=> {
        const dt = job.printingEnd;
        events.push({type: "Printing End", id: job.id, ts: dt, inRange: inRange(dt), job:job});
    })
    pallets.forEach(pallet=> {
        events.push({type: "Pallet Load", ts: pallet.loadTime, id: pallet.id, inRange: inRange(pallet.loadTime)});
        if (pallet.unloadTime)
            events.push({type: "Pallet Unload", ts: pallet.unloadTime, id: pallet.id, inRange: inRange(pallet.unloadTime)});
    })


    const formatCell = (e, rowData) => {
        if (!rowData.job) {
            return {backgroundColor: '#f7ff00 ', padding: '6px'}
        }
        else if (rowData.inRange) {
            return { color: "green", padding: '6px' };
        }
        else {
            return { padding: '6px' };
        }
    }

    return (<MaterialTable
        title={''}
        icons={tableIcons}
        columns={[
            {title: 'Type', field: 'type', width: 200},
            {title: 'Id', field: 'id',  cellStyle: (e, rowData) => formatCell(e, rowData)},
            {title: 'Event Time', field: 'ts', defaultSort: "desc", type: 'datetime', width: 250}

        ]}
        data={events}
        options={{
            selection: true,
            selectionProps: rowData => ({
                disabled: rowData.type !== 'Printing End',
                //checked: rowData.inRange,
                // onClick: (event , rowData) => this.handleCheckboxClick(event,rowData),
            }),
            rowStyle: {
                fontSize: 14,
                fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 400,
                padding: '6px'
            },
            cellStyle: {
                padding: '6px'
            }
        }}
        onSelectionChange={(rows) => {
            events.forEach(event=>event.job ? event.job.selected = false : null);
            rows.forEach(row=> {
                if (row.job)
                    row.job.selected = true
            });
        }}
    />);


}

export default PalletEventsTable